import { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import "../StoriesList/StoriesList.scss";
import stickman from "../../../assets/images/stickman.jpg";
import { FaHeart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../utils/apiUtils";

function StoriesList({ allStories, setAllStories }) {
  const [localStories, setLocalStories] = useState(allStories || []);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  // Keep localStories synced with allStories
  useEffect(() => {
    setLocalStories(allStories || []);
  }, [allStories]);

  if (!localStories || localStories.length === 0) {
    return <p>No stories available.</p>;
  }

  const handleLike = async (storyId) => {
    if (!user || !user.uid) {
      // ✅ check Firebase uid
      alert("You must be logged in to like or unlike a story.");
      return;
    }

    try {
      const res = await fetch(
        `${API_BASE_URL}/api/stories/${storyId}/like`,

        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: user.uid }), // ✅ send uid
        },
      );

      if (!res.ok) {
        const err = await res.json();
        console.error("Like error:", err);
        return;
      }

      const updatedStory = await res.json();

      // Update local state so UI reflects change
      const updatedStories = localStories.map((story) =>
        story._id === storyId ? updatedStory : story,
      );
      setLocalStories(updatedStories);
      setAllStories(updatedStories);
    } catch (err) {
      console.error("Error liking story:", err);
    }
  };

  return (
    <>
      {localStories.map((item) => (
        <div key={item._id} className="stories">
          <div className="storiesList">
            <div className="storiesList__stickman">
              <img src={stickman} alt="stickman" />
            </div>

            <p className="storiesList__date">
              Date submitted:{" "}
              {item.timestamp
                ? new Date(item.timestamp).toLocaleDateString()
                : "Unknown"}
            </p>

            <div className="storiesList__items">
              <h3 className="storiesList__title">{item.title}</h3>
              <h4 className="storiesList__writer">By: {item.name}</h4>
              <p className="storiesList__description">{item.description}</p>

              <div className="storiesList__likes">
                <FaHeart
                  className="storiesList__heart"
                  onClick={() => handleLike(item._id)}
                  style={{
                    cursor: user ? "pointer" : "not-allowed",
                    opacity: user ? 1 : 0.5,
                  }}
                />
                {item.likes?.length || 0}
              </div>

              <button
                className="storiesList__read-more"
                onClick={() =>
                  user
                    ? navigate(`/storyDetail/${item._id}`)
                    : navigate("/login")
                }
              >
                Read More
              </button>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default StoriesList;
